<template>
  <!--勾选-->
  <div class="checkbox">
    <van-checkbox v-model="checked" @change="handleChange" label-disabled>
      <slot name="checkText"></slot>
      <template #icon="props">
        <img
          class="img-icon"
          :src="props.checked ? activeIcon : inactiveIcon"
        />
      </template>
    </van-checkbox>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: true,
      activeIcon: "http://img.wish.hebyun.com.cn/images/confirm_active.png",
      inactiveIcon: "http://img.wish.hebyun.com.cn/images/confirm.png",
    };
  },
  methods: {
    handleChange() {
      this.$emit("changeState", this.checked);
    },
  },
};
</script>

<style lang="scss">

.checkbox {
  position: relative;
  .img-icon {
    height: 16px;
  }
  /deep/.van-checkbox__label {
    font-size: 11px !important;
    letter-spacing: -0.5px;
    color: #999999;
  }
  /deep/.van-checkbox {
    justify-content: center;
  }
  /deep/.van-checkbox__icon {
    width: 16px;
    height: 16px;
  }
}
</style>
